import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-5ca1e5fe"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  key: 0,
  class: "live-channel-dashboard"
};
const _hoisted_2 = {
  class: "top-stats-row"
};
const _hoisted_3 = {
  class: "stat-card resource-overview-card"
};
const _hoisted_4 = {
  class: "stat-content"
};
const _hoisted_5 = {
  class: "stat-card blue-card"
};
const _hoisted_6 = {
  class: "blue-content"
};
const _hoisted_7 = {
  class: "blue-content-label"
};
const _hoisted_8 = {
  class: "blue-content-value"
};
const _hoisted_9 = {
  class: "form_box"
};
const _hoisted_10 = {
  class: "main-content"
};
const _hoisted_11 = {
  class: "left-content"
};
const _hoisted_12 = {
  class: "chart-card user-lag-monitor-card"
};
const _hoisted_13 = {
  class: "monitor-card-content"
};
const _hoisted_14 = {
  class: "monitor-right"
};
const _hoisted_15 = {
  class: "monitor-footer"
};
const _hoisted_16 = {
  class: "chart-row"
};
const _hoisted_17 = {
  class: "chart-col"
};
const _hoisted_18 = {
  class: "chart-card"
};
const _hoisted_19 = {
  class: "chart-summary"
};
const _hoisted_20 = {
  class: "summary-left"
};
const _hoisted_21 = {
  class: "title_label",
  style: {
    "margin-right": "5px"
  }
};
const _hoisted_22 = {
  class: "summary-center"
};
const _hoisted_23 = {
  class: "value_label"
};
const _hoisted_24 = {
  class: "chart-card"
};
const _hoisted_25 = {
  class: "chart-summary"
};
const _hoisted_26 = {
  class: "summary-left"
};
const _hoisted_27 = {
  class: "title_label"
};
const _hoisted_28 = {
  class: "summary-center"
};
const _hoisted_29 = {
  class: "value_label"
};
const _hoisted_30 = {
  class: "chart-card"
};
const _hoisted_31 = {
  class: "chart-col"
};
const _hoisted_32 = {
  class: "chart-card userCard"
};
const _hoisted_33 = {
  class: "gauge-container gauge-container-three"
};
const _hoisted_34 = {
  class: "gauge-item"
};
const _hoisted_35 = {
  style: {
    "position": "relative"
  }
};
const _hoisted_36 = {
  class: "gauge-title"
};
const _hoisted_37 = {
  class: "link_box"
};
const _hoisted_38 = {
  class: "gauge-item"
};
const _hoisted_39 = {
  style: {
    "position": "relative"
  }
};
const _hoisted_40 = {
  class: "gauge-title"
};
const _hoisted_41 = {
  class: "link_box"
};
const _hoisted_42 = {
  class: "gauge-item"
};
const _hoisted_43 = {
  style: {
    "position": "relative"
  }
};
const _hoisted_44 = {
  class: "gauge-title"
};
const _hoisted_45 = {
  class: "link_box"
};
const _hoisted_46 = {
  class: "chart-card"
};
const _hoisted_47 = {
  class: "transcode-summary"
};
const _hoisted_48 = {
  class: "transcode-item"
};
const _hoisted_49 = {
  class: "transcode-label"
};
const _hoisted_50 = {
  class: "transcode-value"
};
const _hoisted_51 = {
  class: "transcode-item"
};
const _hoisted_52 = {
  class: "transcode-label"
};
const _hoisted_53 = {
  class: "transcode-value"
};
const _hoisted_54 = {
  class: "delay-row"
};
const _hoisted_55 = {
  class: "chart-card",
  style: {
    "flex": "1"
  }
};
const _hoisted_56 = {
  key: 0,
  class: "progress-list"
};
const _hoisted_57 = {
  class: "row-title"
};
const _hoisted_58 = {
  class: "row-right"
};
const _hoisted_59 = {
  class: "row-value"
};
const _hoisted_60 = {
  key: 1,
  class: "chart-empty"
};
const _hoisted_61 = {
  class: "chart-card",
  style: {
    "flex": "1"
  }
};
const _hoisted_62 = {
  key: 0,
  class: "progress-list"
};
const _hoisted_63 = {
  class: "row-title"
};
const _hoisted_64 = {
  key: 1,
  class: "chart-empty"
};
const _hoisted_65 = {
  class: "right-sidebar"
};
const _hoisted_66 = {
  class: "ranking-table"
};
const _hoisted_67 = ["src"];
const _hoisted_68 = ["src"];
const _hoisted_69 = ["src"];
const _hoisted_70 = {
  key: 3
};
import { ref, reactive, onMounted, onUnmounted, nextTick } from 'vue';
import * as echarts from 'echarts';
import dayjs from 'dayjs';
import StatItem from '../components/StatItem.vue';
import SearchForm from '@/components/SearchForm/index.vue';
import TipsIcon from '@/components/TipsIcon/index.vue';
import CardHeader from '../components/cardHeader.vue';
import ChannelUtilization from './ChannelUtilization/index.vue';
import AvgFirstFrameStatistics from './avgFirstFrameStatistics/index.vue';
import LaggingRateDetail from './laggingRate/index.vue';
import FirstFrameStatistics from './firstFrameStatistics/index.vue';
import DurationBar from '../components/DurationBar.vue';
import LaggingMonitor from './laggingMonitor/index.vue';
import AvgViewingDuration from './AvgViewingDuration/index.vue';
import LaggingCount from './laggingCount/index.vue';
import DelayedData from './DelayedData/index.vue';
import OnlineRanking from './OnlineRanking/index.vue';
import CompleteTranscode from './completeTranscode/index.vue';
import TranscodeDistribution from './transcodeDistribution/index.vue';
import UserLagMonitor from './UserLagMonitor.vue';
import { getFirstFrameStatisticsApi, getAllCountryListApi, getChannelResourceOverviewApi, getOnlineUsersApi, getOnlineRankingListApi, getBounceRateStatisticsApi, getWatchingDurationStatisticsApi, getTranscodeQualityStatisticsApi, getTranscodeDistributionStatisticsApi, getEndToEndDelayStatisticsApi, getChannelSwitchDelayStatisticsApi, getLaggingMonitorLineChartApi, getLaggingMonitorSingleProgramChartApi, getLaggingMonitorProgramChartApi, getSwitchingSuccessRateStatisticsApi, getLaggingRateStatisticsApi, getInstantOpenRateStatisticsApi, getTranscodeRateDistributionApi } from '@/api/netFly';
import { useI18n } from 'vue-i18n';
import { useCommon } from '@/store/useCommon';
import { Storage, generateQueryTimeRange, removePropertyOfNull, getRecentTwoHoursRange, makeRangeByType } from '@/utils/tools';
import { netflyPresetOptions } from '@/assets/config/dicts';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',

  setup(__props) {
    const {
      t
    } = useI18n();
    const storeCommon = useCommon();
    const countryList = ref([{
      label: t('全部'),
      value: ''
    }]);
    const userLagLineChartData = ref([]);
    const singleProgramChartData = ref([]);
    const segmentedOptions = ref([{
      label: t('时间维度'),
      value: 'time'
    }, {
      label: t('节目维度'),
      value: 'program'
    }]);
    const stutterCountTypeOptions = ref([{
      label: t('全部'),
      value: ''
    }, {
      label: t('500ms以下'),
      value: 'in500ms'
    }, {
      label: t('500ms-1000ms'),
      value: 'in1s'
    }, {
      label: t('1000ms-1500ms'),
      value: 'in2s'
    }, {
      label: t('1500ms以上'),
      value: 'in3s'
    }]);
    const defaultTimeRange = getRecentTwoHoursRange();
    const channelUtilizationObj = ref({
      visible: false,
      mode: 0
    }); // 是否显示主页面

    const showMainPage = computed(() => {
      return !channelUtilizationObj.value.visible && !showAvgFirstFrameStatistics.value && !showLaggingRateDetail.value && !showFirstFrameStatistics.value && !showLaggingMonitor.value && !showLaggingCount.value && !delayedDataObj.value.visible && !showOnlineRanking.value && !showCompleteTranscode.value && !showTranscodeDistribution.value && !showAvgViewingDuration.value;
    });
    const lagMonitorloading = ref(false);
    const showLaggingMonitor = ref(false);
    const showTranscodeDistribution = ref(false);
    const showLaggingCount = ref(false);
    const showOnlineRanking = ref(false);
    const showCompleteTranscode = ref(false);
    const delayedDataObj = ref({
      visible: false,
      mode: 0
    }); // Chart refs

    const firstFrameChartRef = ref(null);
    const playbackRateChartRef = ref(null);
    const bounceRateRef = ref(null);
    const switchRateRef = ref(null);
    const instantOpenRef = ref(null);
    const stutterRef = ref(null);
    const transcodeChartRef = ref(null); // Chart instances

    let firstFrameChart = null;
    let bounceRateChart = null;
    let switchRateChart = null;
    let instantOpenChart = null;
    let stutterChart = null;
    let transcodeChart = null; // 更新首帧时长饼状图数据

    const updateFirstFrameChart = data => {
      if (!firstFrameChart) return; // 将比例值（0-1）转换为百分比（0-100），保留2位小数

      const pieData = [{
        value: Number((data.in500msRatio * 100).toFixed(2)),
        name: '小于500ms',
        itemStyle: {
          color: '#F7C97C'
        }
      }, {
        value: Number((data.in1sRatio * 100).toFixed(2)),
        name: '500ms~1s',
        itemStyle: {
          color: '#73D990'
        }
      }, {
        value: Number((data.in2sRatio * 100).toFixed(2)),
        name: '1s~2s',
        itemStyle: {
          color: '#62B2ED'
        }
      }, {
        value: Number((data.in3sRatio * 100).toFixed(2)),
        name: '2s~3s',
        itemStyle: {
          color: '#70E7DB'
        }
      }, {
        value: Number((data.above3sRatio * 100).toFixed(2)),
        name: '大于3s',
        itemStyle: {
          color: '#F87F6F'
        }
      }];
      firstFrameChart.setOption({
        series: [{
          data: pieData
        }]
      });
    }; // 获取首帧时长+ 首帧平均时长


    const getFirstFrameStatistics = async params => {
      try {
        const {
          code,
          data
        } = await getFirstFrameStatisticsApi(params);

        if (code == 0) {
          statistics.avgFirstFrameDelay = data.avgFirstFrameDelay; // 更新饼状图数据

          updateFirstFrameChart(data);
        }
      } catch (error) {
        console.error('获取首帧时长统计失败:', error);
      }
    }; // 获取卡顿率和秒开率


    const getLaggingAndInstantRate = async params => {
      try {
        // 并发请求卡顿率与秒开率接口，聚合处理
        const [laggingRes, instantRes] = await Promise.all([getLaggingRateStatisticsApi(params), getInstantOpenRateStatisticsApi(params)]);
        const laggingRate = laggingRes?.code === 0 ? laggingRes?.data ?? 0 : 0;
        const instantOpenRate = instantRes?.code === 0 ? instantRes?.data ?? 0 : 0;
        statistics.laggingRate = laggingRate;
        statistics.instantOpenRate = instantOpenRate; // updateGaugeCharts 期待原始 0-1 小数，保持一致

        updateGaugeCharts({
          laggingRate,
          instantOpenRate
        });
      } catch (error) {
        console.error('获取卡顿率/秒开率统计失败:', error);
      }
    }; // 更新播放码率图表


    const updatePlaybackRateChart = data => {
      if (!playbackRateChart) return; // 转码质量对应的顺序：['4k', '1080p+', '1080p', '720p', '576P', '480P']

      const pieData = [{
        value: Number((data.ratio4K * 100).toFixed(2)),
        name: '4k',
        itemStyle: {
          color: '#F7C97C'
        }
      }, {
        value: Number((data.ratio1080pPlus * 100).toFixed(2)),
        name: '1080p+',
        itemStyle: {
          color: '#73D990'
        }
      }, {
        value: Number((data.ratio1080p * 100).toFixed(2)),
        name: '1080p',
        itemStyle: {
          color: '#62B2ED'
        }
      }, {
        value: Number((data.ratio720p * 100).toFixed(2)),
        name: '720p',
        itemStyle: {
          color: '#70E7DB'
        }
      }, {
        value: Number((data.ratio576p * 100).toFixed(2)),
        name: '576P',
        itemStyle: {
          color: '#F87F6F'
        }
      }, {
        value: Number((data.ratio480p * 100).toFixed(2)),
        name: '480P',
        itemStyle: {
          color: '#9B8DFF'
        }
      }];
      playbackRateChart.setOption({
        series: [{
          data: pieData
        }]
      });
    }; // 获取播放码率的数据


    const getPlaybackRateData = async params => {
      try {
        const {
          code,
          data
        } = await getTranscodeRateDistributionApi(params);

        if (code == 0) {
          // 更新饼状图数据
          updatePlaybackRateChart(data);
        }
      } catch (error) {
        console.error('获取播放码率的数据失败:', error);
      }
    }; // 获取频道资源概况


    const getChannelResourceOverview = async () => {
      try {
        const {
          code,
          data
        } = await getChannelResourceOverviewApi();

        if (code == 0) {
          statistics.totalChannels = data.totalChannels;
          statistics.utilizationRate = data.utilizationRate;
          statistics.idleRate = data.idleRate;
        }
      } catch (error) {
        console.error('获取频道资源概况失败:', error);
      }
    }; // 获取所有频道实时在线人数


    const getOnlineUsers = async () => {
      try {
        let params = {
          countryCode: countryConfig.formData.countryCode
        };
        const {
          code,
          data
        } = await getOnlineUsersApi(params);

        if (code == 0) {
          statistics.totalOnlineCount = data.totalOnlineCount;
        }
      } catch (error) {
        console.error('获取所有频道实时在线人数失败:', error);
      }
    }; // 获取实时在线榜单


    const getOnlineRankingList = async () => {
      try {
        let params = {
          countryCode: countryConfig.formData.countryCode
        };
        const {
          code,
          data
        } = await getOnlineRankingListApi(params);

        if (code == 0) {
          // 截取前22条数据
          let top22List = data.length ? data.slice(0, 46) : [];
          rankingData.value = top22List.map((item, index) => {
            return {
              rank: index + 1,
              channelName: item.channelName,
              viewerCount: item.viewerCount
            };
          });
        }
      } catch (error) {
        console.error('获取实时在线榜单失败:', error);
      }
    }; // 更新用户互动图表数据


    const updateUserInteractionCharts = (jumpOutRate, switchingSuccessRate) => {
      if (!bounceRateChart) return;
      if (!switchRateChart) return; // 将小于1的小数（0-1）转换为百分比（0-100），保留2位小数
      //let jumpOutRate = data
      //console.log('jumpOutRate', jumpOutRate)
      //let switchingSuccessRate = data.switchingSuccessRate ? Number((data.switchingSuccessRate * 100).toFixed(2)) : 0
      // 更新跳出率图表

      bounceRateChart.setOption({
        series: [{
          data: [{
            value: jumpOutRate,
            // name: t('跳出率'),
            title: {
              show: true,
              offsetCenter: ['0%', '30%'],
              fontSize: 14,
              color: '#9ca3af'
            },
            detail: {
              valueAnimation: true,
              offsetCenter: ['0%', '0%'],
              formatter: '{value}%',
              fontSize: 22,
              fontWeight: 'bold',
              color: '#333'
            }
          }]
        }]
      }); // 更新切换成功率图表

      switchRateChart.setOption({
        series: [{
          data: [{
            value: switchingSuccessRate,
            //name: t('切换成功率'),
            title: {
              show: true,
              offsetCenter: ['0%', '30%'],
              fontSize: 14,
              color: '#9ca3af'
            },
            detail: {
              valueAnimation: true,
              offsetCenter: ['0%', '0%'],
              formatter: '{value}%',
              fontSize: 22,
              fontWeight: 'bold',
              color: '#333'
            }
          }]
        }]
      });
    }; // 获取跳出率和切换成功率


    const getBounceRateAndSwitchingSuccessRateStatistics = async params => {
      try {
        // 并行请求两个接口，避免多次等待
        const [bounceRes, switchRes] = await Promise.all([getBounceRateStatisticsApi(params), getSwitchingSuccessRateStatisticsApi(params)]); // 跳出率：接口返回 0-1 的小数，转换为百分比

        if (bounceRes && bounceRes.code === 0) {
          const rawBounce = bounceRes.data ?? 0;
          statistics.jumpOutRate = Number((rawBounce * 100).toFixed(2));
        } else {
          statistics.jumpOutRate = 0;
        } // 切换成功率：接口返回 0-1 的小数，转换为百分比


        if (switchRes && switchRes.code === 0) {
          const rawSwitchRate = switchRes.data ?? 0;
          statistics.switchingSuccessRate = Number((rawSwitchRate * 100).toFixed(2));
        } else {
          statistics.switchingSuccessRate = 0;
        } // 更新图表数据


        updateUserInteractionCharts(statistics.jumpOutRate, statistics.switchingSuccessRate);
      } catch (error) {
        console.error('获取跳出率和切换成功率统计失败:', error);
      } finally {}
    }; // 获取观看时长统计


    const getWatchingDurationStatistics = async params => {
      try {
        const {
          code,
          data
        } = await getWatchingDurationStatisticsApi(params);

        if (code == 0) {
          // avgViewingDuration 单位是 min，直接使用
          statistics.avgViewingTime = data || 0;
        }
      } catch (error) {
        console.error('获取观看时长统计失败:', error);
      }
    }; // 更新转码分布图表数据（接口返回 0-1 小数，这里统一转换为百分比整数）


    const updateTranscodeChart = data => {
      if (!transcodeChart) return; // 转码质量对应的x轴顺序：['4K', '1080P+', '1080P', '720P', '576P', '480P']
      // 接口返回的是大于0的整数，直接使用

      const chartDataArray = [data?.count4K ?? 0, data?.count1080pPlus ?? 0, data?.count1080p ?? 0, data?.count720p ?? 0, data?.count576p ?? 0, data?.count480p ?? 0];
      transcodeChart.setOption({
        series: [{
          data: chartDataArray
        }]
      });
    }; // 获取转码质量统计


    const getTranscodeQualityStatistics = async params => {
      try {
        const {
          code,
          data
        } = await getTranscodeQualityStatisticsApi(params);

        if (code == 0) {
          // 完整转码频道数
          statistics.completeTranscodeChannels = data.completeTranscodeChannels || 0; // 完整转码频道数率：将小于1的小数转换为保留两位小数的百分比

          const efficiency = data.completeTranscodeEfficiency || 0;
          statistics.completeTranscodeEfficiency = Number((efficiency * 100).toFixed(2));
        }
      } catch (error) {
        console.error('获取转码质量统计失败:', error);
      }
    }; // 获取转码分布统计


    const getTranscodeDistributionStatistics = async params => {
      try {
        const {
          code,
          data
        } = await getTranscodeDistributionStatisticsApi(params);

        if (code == 0) {
          // 更新转码分布图表
          updateTranscodeChart(data);
        }
      } catch (error) {
        console.error('获取转码分布统计失败:', error);
      }
    }; // 获取频道切换延时统计


    const getChannelSwitchDelayStatistics = async params => {
      try {
        const {
          code,
          data
        } = await getChannelSwitchDelayStatisticsApi(params);

        if (code == 0) {
          // 更新频道切换延时数据
          channelSwitchDelayData.value = data ? data : []; // 更新最大延时值，用于进度条计算

          if (channelSwitchDelayData.value.length > 0) {
            const maxDelay = Math.max(...channelSwitchDelayData.value.map(item => item.data || 0));

            if (maxDelay > 0) {
              // 动态更新最大延时值，向上取整到最近的整数
              maxSwitchDelaySeconds.value = Math.ceil(maxDelay);
            }
          }
        }
      } catch (error) {
        console.error('获取频道切换延时统计失败:', error);
      }
    }; // 获取端到端延时统计


    const getEndToEndDelayStatistics = async params => {
      try {
        const {
          code,
          data
        } = await getEndToEndDelayStatisticsApi(params);

        if (code == 0) {
          // 更新端到端延时数据
          endToEndDelayData.value = data ? data : []; // 更新最大延时值，用于进度条计算

          if (endToEndDelayData.value.length > 0) {
            const maxDelay = Math.max(...endToEndDelayData.value.map(item => item.data || 0));

            if (maxDelay > 0) {
              // 动态更新最大延时值，取两个数据源中的最大值
              const currentMax = maxEndToEndDelaySeconds.value;
              maxEndToEndDelaySeconds.value = Math.max(currentMax, Math.ceil(maxDelay));
              console.log('maxEndToEndDelaySeconds', maxEndToEndDelaySeconds.value);
            }
          }
        }
      } catch (error) {
        console.error('获取端到端延时统计失败:', error);
      }
    }; // 获取折线图数据（时间维度）


    const getUserLagLineChartData = async params => {
      try {
        lagMonitorloading.value = true;
        const {
          code,
          data
        } = await getLaggingMonitorLineChartApi(params);

        if (code == 0) {
          userLagLineChartData.value = data || [];
        }
      } catch (error) {} finally {
        lagMonitorloading.value = false;
      }
    }; // 获取折线图数据（节目维度）


    const getUserLagProgramChartData = async params => {
      try {
        lagMonitorloading.value = true;
        const {
          code,
          data
        } = await getLaggingMonitorProgramChartApi(params);

        if (code == 0) {
          if (data && data.length > 0) {
            // 接口返回格式: [{ channelName, userLaggingList }]
            // 转换为图表需要的格式: [{ programName, data }]
            userLagLineChartData.value = data.map(item => ({
              programName: item.channelName === '总体' ? t('总体') : item.channelName,
              data: (item.userLaggingList || []).map(lagItem => ({
                date: lagItem.date,
                laggingPer500UserCount: lagItem.laggingPer500UserCount,
                laggingUserCount: lagItem.laggingUserCount,
                playUserCount: lagItem.playUserCount
              }))
            }));
          } else {
            userLagLineChartData.value = [];
          }
        }
      } catch (error) {
        console.error('获取节目维度数据失败:', error);
        userLagLineChartData.value = [];
      } finally {
        lagMonitorloading.value = false;
      }
    }; // 处理维度切换


    const handleDimensionChange = SegmentedValue => {
      // 根据维度重新获取数据
      const {
        datePreset,
        dateRange,
        date,
        dimension,
        ...restFormData
      } = searchConfig.formData;
      const {
        startTime: queryStartTime,
        endTime: queryEndTime
      } = generateQueryTimeRange(searchConfig.formData);
      const params = { ...restFormData,
        startTime: queryStartTime,
        endTime: queryEndTime,
        dimension,
        page: 1,
        pageSize: 10
      };

      if (SegmentedValue === 'program') {
        getUserLagProgramChartData(removePropertyOfNull(params));
      } else if (SegmentedValue === 'time') {
        getUserLagLineChartData(removePropertyOfNull(params));
      } else {
        getSingleProgramChartData(removePropertyOfNull(params));
      }
    }; // 获取单频道维度折线图数据


    const getSingleProgramChartData = async params => {
      try {
        lagMonitorloading.value = true;
        const {
          code,
          data
        } = await getLaggingMonitorSingleProgramChartApi(params);

        if (code == 0) {
          userLagLineChartData.value = data.length ? data.map(item => {
            return {
              data: item.userLaggingList,
              cdnTypeName: `Type ${item.cdnType}`,
              cdnType: item.cdnType,
              channelId: item.channelId,
              channelName: item.channelName,
              channelKey: `${item.channelId}_${item.cdnType}_${item.channelName}`,
              callsign: '',
              channelOrder: '',
              displayName: item.channelName
            };
          }) : [];
        }
      } catch (error) {
        console.error('获取单频道维度数据失败:', error);
      } finally {
        lagMonitorloading.value = false;
      }
    }; // 更新图表数据


    const updateGaugeCharts = data => {
      if (!instantOpenChart) return;
      if (!stutterChart) return; // 将小于1的小数（0-1）转换为百分比（0-100），保留2位小数

      let instantOpenRate = Number((data.instantOpenRate * 100).toFixed(2));
      let laggingRate = Number((data.laggingRate * 100).toFixed(2)); // 更新秒开率图表，保留完整的配置结构

      instantOpenChart.setOption({
        series: [{
          data: [{
            value: instantOpenRate,
            //name: t('秒开率'),
            title: {
              show: true,
              offsetCenter: ['0%', '30%'],
              fontSize: 14,
              color: '#9ca3af'
            },
            detail: {
              valueAnimation: true,
              offsetCenter: ['0%', '0%'],
              formatter: '{value}%',
              fontSize: 22,
              fontWeight: 'bold',
              color: '#333'
            }
          }]
        }]
      }); // 更新卡顿率图表，保留完整的配置结构

      stutterChart.setOption({
        series: [{
          data: [{
            value: laggingRate,
            name: t('卡顿率'),
            title: {
              show: true,
              offsetCenter: ['0%', '30%'],
              fontSize: 14,
              color: '#9ca3af'
            },
            detail: {
              valueAnimation: true,
              offsetCenter: ['0%', '0%'],
              formatter: '{value}%',
              fontSize: 22,
              fontWeight: 'bold',
              color: '#333'
            }
          }]
        }]
      });
    };

    const showAvgViewingDuration = ref(false);
    const loading = ref(false);
    const showAvgFirstFrameStatistics = ref(false);
    const showLaggingRateDetail = ref(false); // 当前显示的指标类型

    const currentMetricType = ref('laggingRate');
    const showFirstFrameStatistics = ref(false);
    const segementedValue = ref('time');
    const statistics = reactive({
      totalChannels: 0,
      utilizationRate: 0,
      idleRate: 0,
      totalOnlineCount: 0,
      avgFirstFrameDelay: 0,
      avgViewingTime: 0,
      instantOpenRate: 0,
      switchRate: 0,
      laggingRate: 0,
      switchingSuccessRate: 0,
      jumpOutRate: 0,
      completeTranscodeChannels: 0,
      completeTranscodeEfficiency: 0
    });
    const countryConfig = reactive({
      size: {
        sm: 24,
        md: 24,
        lg: 12,
        xl: 6,
        xs: {}
      },
      formList: [{
        label: '国家',
        prop: 'countryCode',
        widgetType: 'Select',
        list: countryList,
        change: val => {
          // 国家选择变化时立即加载所有数据
          fetchAllData();
        }
      }],
      formData: {
        countryCode: ''
      }
    });
    const searchConfig = reactive({
      size: {
        sm: 24,
        md: 24,
        lg: 12,
        xl: 6,
        xs: {}
      },
      formList: [{
        label: '时间维度',
        prop: 'dimension',
        widgetType: 'Select',
        list: [{
          label: t('时间段'),
          value: '30min'
        }, {
          label: t('日期'),
          value: 'day'
        }],
        change: val => {
          // 时间维度变化时，重置日期范围和日期选择
          if (val === '30min') {
            // 时间段
            // 重置为默认的「过去两小时」窗口
            const {
              startTime,
              endTime,
              date
            } = getRecentTwoHoursRange();
            searchConfig.formData.startTime = startTime;
            searchConfig.formData.endTime = endTime;
            searchConfig.formData.date = dayjs().format('YYYY-MM-DD');
          } else {
            // 日期维度，恢复默认日期范围
            searchConfig.formData.datePreset = '7';
            searchConfig.formData.dateRange = makeRangeByType('7');
            searchConfig.formData.date = '';
            searchConfig.formData.startTime = '';
            searchConfig.formData.endTime = ''; // 更新dateRange的type为daterange

            const dateRangeItem = searchConfig.formList.find(item => item.prop === 'dateRange');

            if (dateRangeItem) {
              dateRangeItem.type = 'daterange';
              dateRangeItem.format = 'YYYY-MM-DD';
              dateRangeItem.valueFormat = 'YYYY-MM-DD';
            }
          }
        }
      }, {
        label: '日期',
        prop: 'datePreset',
        widgetType: 'Select',
        list: netflyPresetOptions,
        // 只有当时间维度为day时才显示
        controller: (val, formData) => {
          return formData.dimension === 'day';
        },
        change: val => {
          if (val === 'all') {
            searchConfig.formData.dateRange = [];
          } else {
            searchConfig.formData.dateRange = makeRangeByType(val);
          }
        }
      }, {
        label: '',
        prop: 'dateRange',
        widgetType: 'date',
        labelWidth: '0px',
        type: 'daterange',
        format: 'YYYY-MM-DD',
        valueFormat: 'YYYY-MM-DD',
        clearable: false,
        change: val => {
          // 只有当时间维度为day时，才将日期选择设为全部
          if (searchConfig.formData.dimension === 'day') {
            searchConfig.formData.datePreset = 'all';
          }
        },
        controller: (val, formData) => {
          // 时间维度是 日、月才显示日期范围选择
          return formData.dimension !== '30min';
        }
      }, {
        label: '',
        prop: 'date',
        widgetType: 'date',
        labelWidth: '0px',
        type: 'date',
        format: 'YYYY-MM-DD',
        valueFormat: 'YYYY-MM-DD',
        clearable: false,
        controller: (val, formData) => {
          // 时间维度是时间段，才显示单独一天的选择
          return formData.dimension === '30min';
        }
      }, {
        label: '',
        prop: 'startTime',
        widgetType: 'timeSelect',
        labelWidth: '0px',
        placeholder: '开始时间',
        start: '00:00',
        end: '23:30',
        format: 'HH:mm',
        valueFormat: 'HH:mm',
        clearable: false,
        change: val => {
          searchConfig.formData.dimension = '30min';
          const endTimeItem = searchConfig.formList.find(item => item.prop === 'endTime');

          if (endTimeItem) {
            if (val) {
              endTimeItem.minTime = val;

              if (searchConfig.formData.endTime && searchConfig.formData.endTime < val) {
                searchConfig.formData.endTime = '';
              }
            } else {
              delete endTimeItem.minTime;
            }
          }
        },
        controller: (val, formData) => {
          return formData.dimension === '30min';
        }
      }, {
        label: '',
        prop: 'endTime',
        widgetType: 'timeSelect',
        labelWidth: '0px',
        start: '00:00',
        placeholder: '结束时间',
        end: '23:30',
        format: 'HH:mm',
        valueFormat: 'HH:mm',
        clearable: false,
        change: val => {
          searchConfig.formData.dimension = '30min';
          const startTimeItem = searchConfig.formList.find(item => item.prop === 'startTime');

          if (startTimeItem) {
            if (val) {
              startTimeItem.maxTime = val;

              if (searchConfig.formData.startTime && searchConfig.formData.startTime > val) {
                searchConfig.formData.startTime = '';
              }
            } else {
              delete startTimeItem.maxTime;
            }
          }
        },
        controller: (val, formData) => {
          return formData.dimension === '30min';
        }
      }],
      formData: {
        dimension: 'day',
        datePreset: '7',
        dateRange: makeRangeByType('7'),
        startTime: '',
        endTime: '',
        date: dayjs().format('YYYY-MM-DD')
      }
    }); // Delay data for progress bars
    // 频道切换延时数据

    const channelSwitchDelayData = ref([]); // 端到端延时数据

    const endToEndDelayData = ref([]); // 卡顿次数数据

    const stutterCountData = ref([]); // 最大频道切换延时秒数（用于进度条计算，动态更新）

    const maxSwitchDelaySeconds = ref(5); // 最大端到端延时秒数（用于进度条计算，动态更新）

    const maxEndToEndDelaySeconds = ref(5); // 最大卡顿次数（用于进度条计算，动态更新）

    const maxStutterCount = ref(100);
    const switchDelayColor = '#F7C97C';
    const endToEndDelayColor = '#4EA5FF';
    const stutterCountColor = '#F87F6F'; // 实时在线榜单数据

    const rankingData = ref([]); // Initialize charts

    const initCharts = () => {
      initFirstFrameChart();
      initPlaybackRateChart();
      initGaugeCharts();
      initTranscodeChart();
    }; // First Frame Duration Chart


    const initFirstFrameChart = () => {
      if (!firstFrameChartRef.value) return;
      firstFrameChart = echarts.init(firstFrameChartRef.value);
      const option = {
        tooltip: {
          trigger: 'item',
          formatter: '{b}: {d}%'
        },
        legend: {
          orient: 'horizontal',
          bottom: 0,
          data: ['小于500ms', '500ms~1s', '1s~2s', '2s~3s', '大于3s'],
          itemGap: 20
        },
        series: [{
          name: '首帧时长',
          type: 'pie',
          radius: '70%',
          label: {
            show: true,
            position: 'outside',
            formatter: '{d}%',
            color: '#bfbfbf',
            fontSize: 12
          },
          labelLine: {
            show: true,
            length: 14,
            length2: 10,
            lineStyle: {
              color: '#e5e7eb'
            }
          },
          data: [{
            value: 12.43,
            name: '小于500ms',
            itemStyle: {
              color: '#F7C97C'
            }
          }, {
            value: 12.26,
            name: '500ms~1s',
            itemStyle: {
              color: '#73D990'
            }
          }, {
            value: 16.87,
            name: '1s~2s',
            itemStyle: {
              color: '#62B2ED'
            }
          }, {
            value: 25.75,
            name: '2s~3s',
            itemStyle: {
              color: '#70E7DB'
            }
          }, {
            value: 32.68,
            name: '大于3s',
            itemStyle: {
              color: '#F87F6F'
            }
          }],
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }]
      };
      firstFrameChart.setOption(option);
    }; // Playback Rate Statistics Chart


    let playbackRateChart = null;

    const initPlaybackRateChart = () => {
      if (!playbackRateChartRef.value) return;
      playbackRateChart = echarts.init(playbackRateChartRef.value);
      const option = {
        tooltip: {
          trigger: 'item',
          formatter: '{b}: {d}%'
        },
        legend: {
          orient: 'horizontal',
          bottom: 0,
          data: ['4k', '1080p+', '1080p', '720p', '576P', '480P'],
          itemGap: 20
        },
        series: [{
          name: '播放码率统计',
          type: 'pie',
          radius: '70%',
          label: {
            show: true,
            position: 'outside',
            formatter: '{d}%',
            color: '#bfbfbf',
            fontSize: 12
          },
          labelLine: {
            show: true,
            length: 14,
            length2: 10,
            lineStyle: {
              color: '#e5e7eb'
            }
          },
          data: [],
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }]
      };
      playbackRateChart.setOption(option);
    };

    const handleBackFromLaggingMonitor = () => {
      showLaggingMonitor.value = false;
      reloadPageAndCharts();
    };

    const handleBackFromAvgViewingDuration = () => {
      showAvgViewingDuration.value = false;
      reloadPageAndCharts();
    }; // Gauge Charts


    const initGaugeCharts = () => {
      // Bounce Rate
      if (bounceRateRef.value) {
        bounceRateChart = echarts.init(bounceRateRef.value);
        const bounceOption = {
          series: [{
            type: 'gauge',
            startAngle: 90,
            endAngle: -270,
            clockwise: false,
            pointer: {
              show: false
            },
            progress: {
              show: true,
              overlap: false,
              roundCap: false,
              clip: false,
              itemStyle: {
                color: '#6A86F5'
              }
            },
            axisLine: {
              lineStyle: {
                width: 22,
                color: [[1, '#E6ECF2']]
              }
            },
            splitLine: {
              show: false,
              distance: -45,
              length: 14,
              lineStyle: {
                width: 2,
                color: '#999'
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              show: false,
              distance: -50,
              color: '#999',
              fontSize: 12
            },
            data: [{
              value: statistics.jumpOutRate,
              name: '跳出率',
              title: {
                show: true,
                offsetCenter: ['0%', '30%'],
                fontSize: 14,
                color: '#9ca3af'
              },
              detail: {
                valueAnimation: true,
                offsetCenter: ['0%', '0%'],
                formatter: '{value}%',
                fontSize: 22,
                fontWeight: 'bold',
                color: '#333'
              }
            }],
            title: {
              fontSize: 14
            }
          }]
        };
        bounceRateChart.setOption(bounceOption);
      } // Switch Rate


      if (switchRateRef.value) {
        switchRateChart = echarts.init(switchRateRef.value);
        const switchOption = {
          series: [{
            type: 'gauge',
            startAngle: 90,
            endAngle: -270,
            clockwise: false,
            pointer: {
              show: false
            },
            progress: {
              show: true,
              overlap: false,
              roundCap: false,
              clip: false,
              itemStyle: {
                color: '#34D2B4'
              }
            },
            axisLine: {
              lineStyle: {
                width: 22,
                color: [[1, '#E6ECF2']]
              }
            },
            splitLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              show: false
            },
            data: [{
              value: statistics.switchingSuccessRate,
              name: '切换成功率',
              title: {
                show: true,
                offsetCenter: ['0%', '30%'],
                fontSize: 14,
                color: '#9ca3af'
              },
              detail: {
                valueAnimation: true,
                offsetCenter: ['0%', '0%'],
                formatter: '{value}%',
                fontSize: 22,
                fontWeight: 'bold',
                color: '#333'
              }
            }],
            title: {
              fontSize: 14
            }
          }]
        };
        switchRateChart.setOption(switchOption);
      } // Instant Open Rate


      if (instantOpenRef.value) {
        instantOpenChart = echarts.init(instantOpenRef.value);
        const instantOpenOption = {
          series: [{
            type: 'gauge',
            startAngle: 90,
            endAngle: -270,
            clockwise: false,
            pointer: {
              show: false
            },
            progress: {
              show: true,
              overlap: false,
              roundCap: false,
              clip: false,
              itemStyle: {
                color: '#FF7B8C'
              }
            },
            axisLine: {
              lineStyle: {
                width: 22,
                color: [[1, '#E6ECF2']]
              }
            },
            splitLine: {
              show: false,
              distance: -45,
              length: 14,
              lineStyle: {
                width: 2,
                color: '#999'
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              show: false,
              distance: -50,
              color: '#999',
              fontSize: 12
            },
            data: [{
              value: statistics.instantOpenRate,
              name: '秒开率',
              title: {
                show: true,
                offsetCenter: ['0%', '30%'],
                fontSize: 14,
                color: '#9ca3af'
              },
              detail: {
                valueAnimation: true,
                offsetCenter: ['0%', '0%'],
                formatter: '{value}%',
                fontSize: 22,
                fontWeight: 'bold',
                color: '#333'
              }
            }],
            title: {
              fontSize: 14
            }
          }]
        };
        instantOpenChart.setOption(instantOpenOption);
      } // Stutter Rate (现在在用户卡顿监控卡片中使用)


      if (stutterRef.value) {
        stutterChart = echarts.init(stutterRef.value); // 将0-1的小数转换为0-100的百分比

        const laggingRateValue = statistics.laggingRate ? Number((statistics.laggingRate * 100).toFixed(2)) : 0;
        const stutterOption = {
          series: [{
            type: 'gauge',
            startAngle: 90,
            endAngle: -270,
            clockwise: false,
            pointer: {
              show: false
            },
            progress: {
              show: true,
              overlap: false,
              roundCap: false,
              clip: false,
              itemStyle: {
                color: '#FCC775'
              }
            },
            axisLine: {
              lineStyle: {
                width: 22,
                color: [[1, '#E6ECF2']]
              }
            },
            splitLine: {
              show: false,
              distance: -45,
              length: 14,
              lineStyle: {
                width: 2,
                color: '#999'
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              show: false,
              distance: -50,
              color: '#999',
              fontSize: 12
            },
            data: [{
              value: laggingRateValue,
              name: t('卡顿率'),
              title: {
                show: true,
                offsetCenter: ['0%', '30%'],
                fontSize: 14,
                color: '#9ca3af'
              },
              detail: {
                valueAnimation: true,
                offsetCenter: ['0%', '0%'],
                formatter: '{value}%',
                fontSize: 22,
                fontWeight: 'bold',
                color: '#333'
              }
            }],
            title: {
              fontSize: 14
            }
          }]
        };
        stutterChart.setOption(stutterOption);
      }
    }; // Transcode Quality Chart


    const initTranscodeChart = () => {
      if (!transcodeChartRef.value) return;
      transcodeChart = echarts.init(transcodeChartRef.value);
      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: params => {
            if (!Array.isArray(params) || params.length === 0) return '';
            const item = params[0];
            const value = typeof item.value === 'number' ? item.value : 0; // 直接按整数展示

            return `${item.axisValueLabel || item.axisValue}<br />${value} ${t('次')}`;
          }
        },
        grid: {
          left: '10%',
          right: '10%',
          top: '10%',
          bottom: '15%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: ['4K', '1080P+', '1080P', '720P', '576P', '480P'],
          axisLabel: {
            fontSize: 12,
            color: '#929BA3'
          },
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          }
        },
        yAxis: {
          type: 'value',
          min: 0,
          axisLabel: {
            fontSize: 12,
            color: '#929BA3',
            formatter: value => `${value}`
          },
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#E5E5E5',
              type: 'solid',
              width: 1
            }
          }
        },
        series: [{
          data: [70, 35, 50, 85, 140, 35],
          type: 'bar',
          barWidth: '14px',
          itemStyle: {
            color: '#FCC775',
            borderRadius: 4
          }
        }]
      };
      transcodeChart.setOption(option);
    }; // Delay charts removed: replaced by Element Plus progress bars
    // 获取国家列表


    const getCountryList = async () => {
      try {
        // 从 pinia 获取语言
        const language = storeCommon.lang || 'en'; // 请求接口

        const {
          code,
          data
        } = await getAllCountryListApi(language);

        if (code == '0') {
          // 将接口返回的数据转换为需要的格式，并在前面添加"全部"选项
          const list = [{
            label: t('全部'),
            value: ''
          }, ...data];
          countryList.value = list; // 保存到 sessionStorage

          Storage.sessionSet('netFlyCountryList', list);
        }
      } catch (error) {
        console.error('获取国家列表失败:', error);
      }
    }; // 获取所有数据


    const fetchAllData = async () => {
      try {
        loading.value = true;
        const {
          datePreset,
          dateRange,
          date,
          ...restFormData
        } = searchConfig.formData;
        const {
          startTime: queryStartTime,
          endTime: queryEndTime
        } = generateQueryTimeRange(searchConfig.formData);
        let params = { ...restFormData,
          countryCode: countryConfig.formData.countryCode,
          startTime: queryStartTime,
          endTime: queryEndTime,
          page: 1,
          pageSize: 10
        }; // 获取有接口的数据

        await Promise.all([getChannelResourceOverview(), getOnlineUsers(), getOnlineRankingList(), getFirstFrameStatistics(params), getBounceRateAndSwitchingSuccessRateStatistics(params), getLaggingAndInstantRate(params), getChannelSwitchDelayStatistics(params), getTranscodeQualityStatistics(params), getTranscodeDistributionStatistics(params), getEndToEndDelayStatistics(params), getWatchingDurationStatistics(params), getPlaybackRateData(params), // 根据当前维度选择调用不同的接口
        segementedValue.value === 'program' ? getUserLagProgramChartData(removePropertyOfNull(params)) : getUserLagLineChartData(removePropertyOfNull(params)) //getLaggingCountList(removePropertyOfNull(params))
        ]);
      } catch (error) {
        console.error('获取数据失败:', error);
      } finally {
        loading.value = false;
      }
    }; // Handle date change


    const onSearch = val => {
      // 搜索时获取数据
      fetchAllData();
    };

    const onReset = () => {
      searchConfig.formData.dimension = 'day';
      searchConfig.formData.datePreset = '7';
      searchConfig.formData.dateRange = makeRangeByType('7');
      searchConfig.formData.date = '';
      searchConfig.formData.startTime = '';
      searchConfig.formData.endTime = ''; // 重置后获取数据

      fetchAllData();
    }; // Handle channel detail click


    const handleChannelDetailClick = mode => {
      // 显示频道 利用率||闲置率 详情页面
      channelUtilizationObj.value.visible = true;
      channelUtilizationObj.value.mode = mode;
    }; // 显示频道切换延时、端到端延时详情页面


    const onShowDelayedData = mode => {
      delayedDataObj.value.visible = true;
      delayedDataObj.value.mode = mode;
    }; // 显示首帧统计页面


    const onShowChannelUtilization = () => {
      showAvgFirstFrameStatistics.value = true;
    }; // 显示平均观看时长详情页面


    const onShowAvgViewingDuration = () => {
      showAvgViewingDuration.value = true;
    }; // 显示卡顿次数统计页面


    const onShowLaggingCount = () => {
      showLaggingCount.value = true;
    }; // 从卡顿次数统计页面返回


    const handleBackFromLaggingCount = () => {
      showLaggingCount.value = false;
      reloadPageAndCharts();
    }; // 从频道切换延时、端到端延时详情页面返回


    const handleBackFromDelayedData = () => {
      delayedDataObj.value.visible = false;
      reloadPageAndCharts();
    }; // 从实时在线榜单页面返回


    const handleBackFromOnlineRanking = () => {
      showOnlineRanking.value = false;
      reloadPageAndCharts();
    }; // 从完整转码页面返回


    const handleBackFromCompleteTranscode = () => {
      showCompleteTranscode.value = false;
      reloadPageAndCharts();
    }; // 显示完整转码页面


    const onShowCompleteTranscode = () => {
      showCompleteTranscode.value = true;
    }; // 显示转码分布页面


    const onShowTranscodeDistribution = () => {
      showTranscodeDistribution.value = true;
    }; // 从转码分布页面返回


    const handleBackFromTranscodeDistribution = () => {
      showTranscodeDistribution.value = false;
      reloadPageAndCharts();
    }; // 显示实时在线榜单页面


    const onShowOnlineRankingDetail = () => {
      showOnlineRanking.value = true;
    }; // 重新加载页面和图表


    const reloadPageAndCharts = async () => {
      try {
        loading.value = true; // 先销毁所有现有的图表实例

        if (firstFrameChart) {
          firstFrameChart.dispose();
          firstFrameChart = null;
        }

        if (bounceRateChart) {
          bounceRateChart.dispose();
          bounceRateChart = null;
        }

        if (switchRateChart) {
          switchRateChart.dispose();
          switchRateChart = null;
        }

        if (instantOpenChart) {
          instantOpenChart.dispose();
          instantOpenChart = null;
        }

        if (stutterChart) {
          stutterChart.dispose();
          stutterChart = null;
        }

        if (transcodeChart) {
          transcodeChart.dispose();
          transcodeChart = null;
        } // 等待 DOM 更新和渲染完成


        await nextTick();
        await new Promise(resolve => setTimeout(resolve, 100)); // 重新初始化所有图表

        initCharts(); // 重新获取数据

        await fetchAllData(); // 调整图表大小

        handleResize();
      } catch (error) {
        console.error('重新加载页面和图表失败:', error);
      } finally {
        loading.value = false;
      }
    }; // 从详情页面返回


    const handleBackFromUtilization = () => {
      channelUtilizationObj.value.visible = false;
      reloadPageAndCharts();
    }; // 从首帧统计页面返回


    const handleBackFromFirstFrameStatistics = () => {
      showAvgFirstFrameStatistics.value = false;
      reloadPageAndCharts();
    }; // 显示卡帧率详情页面


    const onShowLaggingRateDetail = () => {
      console.log('显示卡帧率详情页面');
      currentMetricType.value = 'laggingRate';
      showLaggingRateDetail.value = true;
    }; // 显示跳出率详情页面


    const onShowBounceRateDetail = () => {
      currentMetricType.value = 'bounceRate';
      showLaggingRateDetail.value = true;
    }; // 显示切换成功率详情页面


    const onShowSwitchingSuccessRateDetail = () => {
      currentMetricType.value = 'switchingSuccessRate';
      showLaggingRateDetail.value = true;
    }; // 显示秒开率详情页面


    const onShowInstantOpenRateDetail = () => {
      currentMetricType.value = 'instantOpenRate';
      showLaggingRateDetail.value = true;
    }; // 从卡帧率详情页面返回


    const handleBackFromLaggingRateDetail = () => {
      showLaggingRateDetail.value = false;
      reloadPageAndCharts();
    }; // 显示首帧累计时长统计页面


    const onShowFirstFrameStatistics = () => {
      showFirstFrameStatistics.value = true;
    }; // 从首帧累计时长统计页面返回


    const handleBackFromFirstFrameCumulativeStatistics = () => {
      showFirstFrameStatistics.value = false;
      reloadPageAndCharts();
    }; // Format number with thousand separators


    const formatNumber = num => {
      if (!num) return '0';
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }; // Resize handler


    const handleResize = () => {
      if (firstFrameChart) firstFrameChart.resize();
      if (playbackRateChart) playbackRateChart.resize();
      if (bounceRateChart) bounceRateChart.resize();
      if (switchRateChart) switchRateChart.resize();
      if (instantOpenChart) instantOpenChart.resize();
      if (stutterChart) stutterChart.resize();
      if (transcodeChart) transcodeChart.resize();
    };

    onMounted(() => {
      setTimeout(() => {
        initCharts();
        window.addEventListener('resize', handleResize); // 图表初始化后再获取数据

        getCountryList();
        fetchAllData();
      }, 100);
    });
    onUnmounted(() => {
      window.removeEventListener('resize', handleResize);
      if (firstFrameChart) firstFrameChart.dispose();
      if (playbackRateChart) playbackRateChart.dispose();
      if (bounceRateChart) bounceRateChart.dispose();
      if (switchRateChart) switchRateChart.dispose();
      if (instantOpenChart) instantOpenChart.dispose();
      if (stutterChart) stutterChart.dispose();
      if (transcodeChart) transcodeChart.dispose();
    });
    return (_ctx, _cache) => {
      const _component_el_divider = _resolveComponent("el-divider");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_col = _resolveComponent("el-col");

      const _component_el_row = _resolveComponent("el-row");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_link = _resolveComponent("el-link");

      const _component_el_progress = _resolveComponent("el-progress");

      const _component_el_empty = _resolveComponent("el-empty");

      const _component_el_table_column = _resolveComponent("el-table-column");

      const _component_el_table = _resolveComponent("el-table");

      const _directive_loading = _resolveDirective("loading");

      return _openBlock(), _createElementBlock(_Fragment, null, [_unref(showMainPage) ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(CardHeader, {
        labelText: _ctx.$t('频道资源概况'),
        showTips: "",
        tipsText: `${_ctx.$t('频道总数')}: ${_ctx.$t('平台当前可用的直播频道总数')}
         ${_ctx.$t('过去3天频道利用率')}: ${_ctx.$t('近3天有用户观看超过5分钟的频道占比')}
         ${_ctx.$t('过去3天频道利用率')}: ${_ctx.$t('近3天无用户观看或观看不足5分钟的频道占比')}`
      }, null, 8, ["labelText", "tipsText"]), _createElementVNode("div", _hoisted_4, [_createVNode(StatItem, {
        "icon-src": require('@/assets/imgs/netfly/channel_total.png'),
        label: _ctx.$t('频道总数'),
        value: statistics.totalChannels || '0'
      }, null, 8, ["icon-src", "label", "value"]), _createVNode(_component_el_divider, {
        direction: "vertical",
        style: {
          "height": "45px"
        }
      }), _createVNode(StatItem, {
        "icon-src": require('@/assets/imgs/netfly/channel_use.png'),
        label: _ctx.$t('过去3天频道利用率'),
        value: `${statistics.utilizationRate || '0'}%`,
        "value-type": "utilization",
        "show-detail": true,
        onDetailClick: _cache[0] || (_cache[0] = $event => handleChannelDetailClick(0))
      }, null, 8, ["icon-src", "label", "value"]), _createVNode(_component_el_divider, {
        direction: "vertical",
        style: {
          "height": "45px"
        }
      }), _createVNode(StatItem, {
        "icon-src": require('@/assets/imgs/netfly/channel_idle.png'),
        label: _ctx.$t('过去3天频道闲置率'),
        value: `${statistics.idleRate || '0'}%`,
        "value-type": "alert",
        "show-detail": true,
        onDetailClick: _cache[1] || (_cache[1] = $event => handleChannelDetailClick(1))
      }, null, 8, ["icon-src", "label", "value"])])]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('实时在线人数')), 1), _createElementVNode("div", _hoisted_8, _toDisplayString(formatNumber(statistics.totalOnlineCount)), 1)])])]), _createElementVNode("div", _hoisted_9, [_createVNode(_component_el_form, {
        model: countryConfig.formData,
        inline: true,
        "label-width": '120px'
      }, {
        default: _withCtx(() => [_createVNode(_component_el_row, {
          gutter: 24
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            sm: 24,
            md: 24,
            lg: 12,
            xl: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: _ctx.$t('国家'),
              class: "form_item",
              style: {
                "width": "76%"
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: countryConfig.formData.countryCode,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => countryConfig.formData.countryCode = $event),
                placeholder: "",
                style: {
                  "width": "160px"
                },
                onChange: fetchAllData
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(countryList.value, item => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    key: item.value,
                    label: item.label,
                    value: item.value
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            }, 8, ["label"])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"])]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createVNode(SearchForm, {
        "is-show-btns": true,
        "form-list": searchConfig.formList,
        "form-data": searchConfig.formData,
        size: searchConfig.size,
        gutter: 24,
        onSearch: onSearch,
        onReset: onReset
      }, null, 8, ["form-list", "form-data", "size"]), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_withDirectives(_createVNode(UserLagMonitor, {
        "segmented-options": segmentedOptions.value,
        modelValue: segementedValue.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => segementedValue.value = $event),
        "chart-data": userLagLineChartData.value,
        onShowDetail: _cache[4] || (_cache[4] = $event => showLaggingMonitor.value = true),
        onDimensionChange: handleDimensionChange
      }, null, 8, ["segmented-options", "modelValue", "chart-data"]), [[_directive_loading, lagMonitorloading.value]]), _createVNode(_component_el_divider, {
        direction: "vertical",
        class: "monitor-divider"
      }), _createElementVNode("div", _hoisted_14, [_createVNode(CardHeader, {
        labelText: _ctx.$t('卡顿率'),
        showTips: "",
        tipsText: _ctx.$t('卡顿发生频率及卡顿时长占比')
      }, null, 8, ["labelText", "tipsText"]), _createElementVNode("div", {
        ref_key: "stutterRef",
        ref: stutterRef,
        class: "lagging-rate-chart"
      }, null, 512), _createElementVNode("div", _hoisted_15, [_createVNode(_component_el_link, {
        type: "primary",
        class: "detail-link",
        onClick: onShowLaggingRateDetail
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('数据详情')) + ">", 1)]),
        _: 1
      })])])])]), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_createVNode(CardHeader, {
        labelText: _ctx.$t('首帧时长'),
        showTips: "",
        showDetail: "",
        tipsText: _ctx.$t('不同首帧加载时间区间的分布比例'),
        onClickDetail: onShowFirstFrameStatistics
      }, null, 8, ["labelText", "tipsText"]), _createElementVNode("div", {
        ref_key: "firstFrameChartRef",
        ref: firstFrameChartRef,
        class: "chart-container",
        style: {
          "height": "300px"
        }
      }, null, 512), _createVNode(_component_el_divider), _createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$t('首帧平均时长')), 1), _createVNode(TipsIcon, {
        content: _ctx.$t('用户从点击到看到首帧画面的平均等待时间'),
        iconUrl: require('@/assets/imgs/netfly/detail.png')
      }, null, 8, ["content", "iconUrl"])]), _createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, _toDisplayString(statistics.avgFirstFrameDelay) + " (ms)", 1), _createVNode(_component_el_link, {
        type: "primary",
        class: "summary-link",
        style: {
          "margin-left": "10px"
        },
        onClick: onShowChannelUtilization
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('数据详情')) + ">", 1)]),
        _: 1
      })])])]), _createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, [_createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.$t('平均观看时长')), 1)]), _createElementVNode("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, _toDisplayString(statistics.avgViewingTime) + " (min)", 1), _createVNode(_component_el_link, {
        type: "primary",
        class: "summary-link",
        style: {
          "margin-left": "10px"
        },
        onClick: onShowAvgViewingDuration
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('数据详情')) + ">", 1)]),
        _: 1
      })])])]), _createElementVNode("div", _hoisted_30, [_createVNode(CardHeader, {
        labelText: _ctx.$t('播放码率统计'),
        showTips: "",
        showDetail: "",
        onClickDetail: onShowTranscodeDistribution,
        tipsText: _ctx.$t('指定时段内各频道各类转码率的使用情况占比')
      }, null, 8, ["labelText", "tipsText"]), _createElementVNode("div", {
        ref_key: "playbackRateChartRef",
        ref: playbackRateChartRef,
        class: "chart-container",
        style: {
          "height": "300px"
        }
      }, null, 512)])]), _createElementVNode("div", _hoisted_31, [_createElementVNode("div", _hoisted_32, [_createVNode(CardHeader, {
        labelText: _ctx.$t('用户互动分析'),
        showTips: "",
        tipsText: `${_ctx.$t('跳出率')}:${_ctx.$t('观看时长不足5分钟离开的用户比例')} \n ${_ctx.$t('切换成功率')}:${_ctx.$t('频道切换操作的成功率')} \n ${_ctx.$t('秒开率')}:${_ctx.$t('500毫秒内成功开播的用户比例')}`
      }, null, 8, ["labelText", "tipsText"]), _createElementVNode("div", _hoisted_33, [_createElementVNode("div", _hoisted_34, [_createElementVNode("div", _hoisted_35, [_createElementVNode("div", {
        ref_key: "bounceRateRef",
        ref: bounceRateRef,
        class: "gauge-chart",
        style: {
          "height": "220px",
          "width": "190px"
        }
      }, null, 512), _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.$t('跳出率')), 1)]), _createElementVNode("div", _hoisted_37, [_createVNode(_component_el_link, {
        type: "primary",
        class: "detail-link",
        onClick: onShowBounceRateDetail
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('数据详情')) + ">", 1)]),
        _: 1
      })])]), _createElementVNode("div", _hoisted_38, [_createElementVNode("div", _hoisted_39, [_createElementVNode("div", {
        ref_key: "switchRateRef",
        ref: switchRateRef,
        class: "gauge-chart",
        style: {
          "height": "220px",
          "width": "190px"
        }
      }, null, 512), _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.$t('切换成功率')), 1)]), _createElementVNode("div", _hoisted_41, [_createVNode(_component_el_link, {
        type: "primary",
        class: "detail-link",
        onClick: onShowSwitchingSuccessRateDetail
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('数据详情')) + ">", 1)]),
        _: 1
      })])]), _createElementVNode("div", _hoisted_42, [_createElementVNode("div", _hoisted_43, [_createElementVNode("div", {
        ref_key: "instantOpenRef",
        ref: instantOpenRef,
        class: "gauge-chart",
        style: {
          "height": "220px",
          "width": "190px"
        }
      }, null, 512), _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.$t('秒开率')), 1)]), _createElementVNode("div", _hoisted_45, [_createVNode(_component_el_link, {
        type: "primary",
        class: "detail-link",
        onClick: onShowInstantOpenRateDetail
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('数据详情')) + ">", 1)]),
        _: 1
      })])])])]), _createElementVNode("div", _hoisted_46, [_createVNode(CardHeader, {
        labelText: _ctx.$t('完整转码'),
        showTips: "",
        tipsText: _ctx.$t('支持从4K到480P完整转码频道数量及占比；各分辨率转码质量的情况'),
        showDetail: "",
        onClickDetail: onShowCompleteTranscode
      }, null, 8, ["labelText", "tipsText"]), _createElementVNode("div", _hoisted_47, [_createElementVNode("div", _hoisted_48, [_createElementVNode("div", _hoisted_49, _toDisplayString(_ctx.$t('完整转码频道数')), 1), _createElementVNode("div", _hoisted_50, _toDisplayString(formatNumber(statistics.completeTranscodeChannels)), 1)]), _createVNode(_component_el_divider, {
        direction: "vertical",
        class: "transcode-divider"
      }), _createElementVNode("div", _hoisted_51, [_createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.$t('完整转码频道数率')), 1), _createElementVNode("div", _hoisted_53, _toDisplayString(statistics.completeTranscodeEfficiency) + "%", 1)])]), _createVNode(_component_el_divider), _createVNode(CardHeader, {
        labelText: _ctx.$t('转码分布')
      }, null, 8, ["labelText"]), _createElementVNode("div", {
        ref_key: "transcodeChartRef",
        ref: transcodeChartRef,
        class: "chart-container",
        style: {
          "height": "400px"
        }
      }, null, 512)])])]), _createElementVNode("div", _hoisted_54, [_createElementVNode("div", _hoisted_55, [_createVNode(CardHeader, {
        labelText: _ctx.$t('频道切换延时'),
        showTips: "",
        showDetail: "",
        onClickDetail: _cache[5] || (_cache[5] = $event => onShowDelayedData(0)),
        tipsText: _ctx.$t('切换频道所需的平均时间')
      }, null, 8, ["labelText", "tipsText"]), channelSwitchDelayData.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_56, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(channelSwitchDelayData.value, item => {
        return _openBlock(), _createElementBlock("div", {
          class: "progress-row",
          key: item.channelName
        }, [_createElementVNode("div", _hoisted_57, _toDisplayString(item.channelName), 1), _createElementVNode("div", _hoisted_58, [_createVNode(_component_el_progress, {
          percentage: Math.round(item.data / maxSwitchDelaySeconds.value * 100),
          "stroke-width": 8,
          color: switchDelayColor,
          "show-text": false
        }, null, 8, ["percentage"]), _createElementVNode("span", _hoisted_59, _toDisplayString(item.data) + "s", 1)])]);
      }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_60, [_createVNode(_component_el_empty, {
        description: _ctx.$t('暂无数据')
      }, null, 8, ["description"])]))]), _createElementVNode("div", _hoisted_61, [_createVNode(CardHeader, {
        labelText: _ctx.$t('端到端延时'),
        showTips: "",
        showDetail: "",
        onClickDetail: _cache[6] || (_cache[6] = $event => onShowDelayedData(1)),
        tipsText: _ctx.$t('从频道采集到用户播放的整体延迟')
      }, null, 8, ["labelText", "tipsText"]), endToEndDelayData.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_62, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(endToEndDelayData.value, item => {
        return _openBlock(), _createElementBlock("div", {
          class: "progress-row",
          key: item.channelName
        }, [_createElementVNode("div", _hoisted_63, _toDisplayString(item.channelName), 1), _createVNode(DurationBar, {
          value: item.data,
          labelUnit: "s",
          width: 473,
          max: maxEndToEndDelaySeconds.value,
          color: endToEndDelayColor
        }, null, 8, ["value", "max"])]);
      }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_64, [_createVNode(_component_el_empty, {
        description: _ctx.$t('暂无数据')
      }, null, 8, ["description"])]))])])]), _createElementVNode("div", _hoisted_65, [_createVNode(CardHeader, {
        labelText: _ctx.$t('实时在线榜单'),
        showTips: "",
        showDetail: "",
        tipsText: _ctx.$t('在线观看人数前100的内容排行'),
        onClickDetail: onShowOnlineRankingDetail
      }, null, 8, ["labelText", "tipsText"]), _createElementVNode("div", _hoisted_66, [_createVNode(_component_el_table, {
        data: rankingData.value,
        style: {
          "width": "100%"
        },
        stripe: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          prop: "rank",
          label: _ctx.$t('编号'),
          width: "60",
          align: "center"
        }, {
          default: _withCtx(scope => [scope.row.rank === 1 ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: require('@/assets/imgs/netfly/ic_golden.png'),
            class: "rank-icon"
          }, null, 8, _hoisted_67)) : scope.row.rank === 2 ? (_openBlock(), _createElementBlock("img", {
            key: 1,
            src: require('@/assets/imgs/netfly/silver.png'),
            class: "rank-icon"
          }, null, 8, _hoisted_68)) : scope.row.rank === 3 ? (_openBlock(), _createElementBlock("img", {
            key: 2,
            src: require('@/assets/imgs/netfly/copper.png'),
            class: "rank-icon"
          }, null, 8, _hoisted_69)) : (_openBlock(), _createElementBlock("span", _hoisted_70, _toDisplayString(scope.row.rank), 1))]),
          _: 1
        }, 8, ["label"]), _createVNode(_component_el_table_column, {
          prop: "channelName",
          label: _ctx.$t('频道名称'),
          align: "left",
          "show-overflow-tooltip": "",
          "min-width": "170"
        }, null, 8, ["label"]), _createVNode(_component_el_table_column, {
          prop: "viewerCount",
          label: _ctx.$t('观看人数'),
          width: "90",
          align: "left"
        }, null, 8, ["label"])]),
        _: 1
      }, 8, ["data"])])])])])), [[_directive_loading, loading.value]]) : _createCommentVNode("", true), channelUtilizationObj.value.visible ? (_openBlock(), _createBlock(ChannelUtilization, {
        key: 1,
        mode: channelUtilizationObj.value.mode,
        onBack: handleBackFromUtilization
      }, null, 8, ["mode"])) : _createCommentVNode("", true), showAvgFirstFrameStatistics.value ? (_openBlock(), _createBlock(AvgFirstFrameStatistics, {
        key: 2,
        onBack: handleBackFromFirstFrameStatistics
      })) : _createCommentVNode("", true), showLaggingRateDetail.value ? (_openBlock(), _createBlock(LaggingRateDetail, {
        key: 3,
        "metric-type": currentMetricType.value,
        onBack: handleBackFromLaggingRateDetail
      }, null, 8, ["metric-type"])) : _createCommentVNode("", true), showFirstFrameStatistics.value ? (_openBlock(), _createBlock(FirstFrameStatistics, {
        key: 4,
        onBack: handleBackFromFirstFrameCumulativeStatistics
      })) : _createCommentVNode("", true), showLaggingMonitor.value ? (_openBlock(), _createBlock(LaggingMonitor, {
        key: 5,
        onBack: handleBackFromLaggingMonitor
      })) : _createCommentVNode("", true), showAvgViewingDuration.value ? (_openBlock(), _createBlock(AvgViewingDuration, {
        key: 6,
        onBack: handleBackFromAvgViewingDuration
      })) : _createCommentVNode("", true), showLaggingCount.value ? (_openBlock(), _createBlock(LaggingCount, {
        key: 7,
        onBack: handleBackFromLaggingCount
      })) : _createCommentVNode("", true), delayedDataObj.value.visible ? (_openBlock(), _createBlock(DelayedData, {
        key: 8,
        mode: delayedDataObj.value.mode,
        onBack: handleBackFromDelayedData
      }, null, 8, ["mode"])) : _createCommentVNode("", true), showOnlineRanking.value ? (_openBlock(), _createBlock(OnlineRanking, {
        key: 9,
        onBack: handleBackFromOnlineRanking
      })) : _createCommentVNode("", true), showCompleteTranscode.value ? (_openBlock(), _createBlock(CompleteTranscode, {
        key: 10,
        onBack: handleBackFromCompleteTranscode
      })) : _createCommentVNode("", true), showTranscodeDistribution.value ? (_openBlock(), _createBlock(TranscodeDistribution, {
        key: 11,
        onBack: handleBackFromTranscodeDistribution
      })) : _createCommentVNode("", true)], 64);
    };
  }

});